import * as React from "react";
import ProductSlider, { IProductSliderProps } from "~/components/product-slider/product-slider";

export interface IProductSliderViewProps {
    contextModel: IProductSliderProps;
}

class ProductSliderView extends React.PureComponent<IProductSliderViewProps> {
    public render() {
        return <ProductSlider {...this.props.contextModel} />;
    }
}

export default ProductSliderView;
